import styled from "styled-components";

import { ContentHolder } from "commons";

export const AuthContentHolder = styled(ContentHolder)`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
`;
